import {
  deleteElement,
  fetchElements,
  saveElementsType,
  updateElement,
} from "@/lib/utils";
import type {
  OtrosProyectos,
  OtrasActuaciones,
  OtrasTransacciones,
} from "@/types/models/otros";
import type { OtrosRepository } from "@/lib/repositories/interfaces/otros-repository.interface";

const OTROS_PROYECTOS_FIELDS = ["*", "translations.*"] as const;

const OTRAS_ACTUACIONES_FIELDS = ["*", "translations.*"] as const;

const OTRAS_TRANSACCIONES_FIELDS = ["*", "translations.*"] as const;

export const otrosRepository: OtrosRepository = {
  fetchOtrosProyectosByTenant: (tenantId: number): Promise<OtrosProyectos[]> =>
    fetchElements<OtrosProyectos>(
      "otros_proyectos",
      [...OTROS_PROYECTOS_FIELDS],
      undefined,
      {
        tenant: { _eq: tenantId },
      }
    ),

  fetchOtrasActuacionesByTenant: (
    tenantId: number
  ): Promise<OtrasActuaciones[]> =>
    fetchElements<OtrasActuaciones>(
      "otras_actuaciones",
      [...OTRAS_ACTUACIONES_FIELDS],
      undefined,
      {
        otro_proyecto: {
          tenant: { _eq: tenantId },
        },
      }
    ),

  fetchOtrasTransaccionesByTenant: (
    tenantId: number
  ): Promise<OtrasTransacciones[]> =>
    fetchElements<OtrasTransacciones>(
      "otras_transacciones",
      [...OTRAS_TRANSACCIONES_FIELDS],
      undefined,
      {
        otra_actuacion: {
          otro_proyecto: {
            tenant: { _eq: tenantId },
          },
        },
      }
    ),

  createOtroProyecto: async (
    payload: Partial<OtrosProyectos>
  ): Promise<OtrosProyectos> =>
    (await saveElementsType<OtrosProyectos>("otros_proyectos", [payload]))[0],

  updateOtroProyecto: (
    id: number,
    changes: Partial<OtrosProyectos>
  ) => updateElement("otros_proyectos", id, changes),

  deleteOtroProyecto: (id: number): Promise<void> =>
    deleteElement("otros_proyectos", id),

  createOtraActuacion: async (
    payload: Partial<OtrasActuaciones>
  ): Promise<OtrasActuaciones> =>
    (await saveElementsType<OtrasActuaciones>("otras_actuaciones", [payload]))[0],

  updateOtraActuacion: (
    id: number,
    changes: Partial<OtrasActuaciones>
  ) => updateElement("otras_actuaciones", id, changes),

  deleteOtraActuacion: (id: number): Promise<void> =>
    deleteElement("otras_actuaciones", id),

  createOtraTransaccion: async (
    payload: Partial<OtrasTransacciones>
  ): Promise<OtrasTransacciones> =>
    (await saveElementsType<OtrasTransacciones>("otras_transacciones", [payload]))[0],

  updateOtraTransaccion: (
    id: number,
    changes: Partial<OtrasTransacciones>
  ) => updateElement("otras_transacciones", id, changes),

  deleteOtraTransaccion: (id: number): Promise<void> =>
    deleteElement("otras_transacciones", id),
};
